var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdditionalInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65.5229,
    height: 65.5229,
    rx: 32.7615,
    fill: "#F9EBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0664 25.1208V50.4802H29.4805V25.1208H36.0664ZM29.1758 18.5349C29.1758 17.5193 29.4961 16.6833 30.1367 16.0271C30.793 15.3708 31.6758 15.0427 32.7852 15.0427C33.8789 15.0427 34.7461 15.3708 35.3867 16.0271C36.0273 16.6833 36.3477 17.5193 36.3477 18.5349C36.3477 19.5505 36.0273 20.3943 35.3867 21.0662C34.7461 21.7224 33.8789 22.0505 32.7852 22.0505C31.6758 22.0505 30.793 21.7224 30.1367 21.0662C29.4961 20.3943 29.1758 19.5505 29.1758 18.5349Z",
    fill: "#A02524"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalInformation);
export default __webpack_public_path__ + "static/media/additional_information.d86b57fea6c710ccd11dabb6e543808e.svg";
export { ForwardRef as ReactComponent };